import { Typography, Box, Grid } from "@mui/material";

// TODO: Grid is saying its deprecated, but Grid2 link does not lead anywhere
import { AppFormType } from "components/Forms/AppForm";

import EarRequiredSection from "./EarRequiredSection";

interface EarSectionProps {
  productForm: AppFormType | { AppField: any; state: { values: any } };
}

const EarSection = ({ productForm }: EarSectionProps) => {
  return (
    <Box className="mb-4">
      {/* WARN: Custom styling from pre standardization! */}
      {/* TODO: Standardize when you come across this!  */}
      <Typography variant="body1" className="mb-2">
        ENTROPY ASSESSMENT REPORT
      </Typography>
      <div className="border p-3 rounded">
        {/* WARN: Custom styling from pre standardization! */}
        {/* TODO: Standardize when you come across this!  */}
        <Typography variant="body1" sx={{ color: "text.secondary", mb: 2 }}>
          Include details on the Entropy Assessment Report. Provide
          justification if the product does not require an EAR.
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <productForm.AppField
                name="ears.ear_required"
                listeners={{
                  onChange: ({ value }: { value: boolean }) => {
                    value
                      ? // @ts-ignore
                        productForm.resetField("ears.no_ear_justification")
                      : // @ts-ignore
                        productForm.resetField("ears.earData");
                  },
                }}
              >
                {(earRequiredField: any) => (
                  <>
                    <earRequiredField.SingleCheckbox label="This Product Requires an EAR?" />

                    {/* When ear_required changes and is true, initialize earData */}
                    {earRequiredField.state.value && (
                      <>
                        <productForm.AppField name="ears.earData">
                          {(earDataField: any) => {
                            if (
                              !productForm.state.values.ears.earData ||
                              productForm.state.values.ears.earData.length === 0
                            ) {
                              earDataField.handleChange([
                                {
                                  earid: undefined,
                                  apriori: false,
                                  earFiles: [],
                                },
                              ]);
                            }
                            return (
                              <EarRequiredSection
                                productForm={productForm}
                                handleChange={earDataField.handleChange}
                              />
                            );
                          }}
                        </productForm.AppField>
                      </>
                    )}

                    {/* Ear is not required */}
                    {!earRequiredField.state.value && (
                      <productForm.AppField name="ears.no_ear_justification">
                        {(field: any) => (
                          <field.HtmlEditor
                            label="Justification for No EAR Required:"
                            required
                          />
                        )}
                      </productForm.AppField>
                    )}
                  </>
                )}
              </productForm.AppField>
            </Box>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
};

export default EarSection;
